import { render, staticRenderFns } from "./FCheckboxGroup.vue?vue&type=template&id=59e0d4ac&"
import script from "./FCheckboxGroup.vue?vue&type=script&lang=ts&"
export * from "./FCheckboxGroup.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports